import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantSetpoints.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialModelVariantState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import InputNumber from '../WSAControls/InputNumber/InputNumber';
import classNames from 'classnames';
import { isRequired } from '../../utils';
import Cookies from 'js-cookie';
import { useParams } from 'react-router-dom';

const ModelVariantSetpoints = ({
  ModelSetpointId,
  saveModelVariantSetpoint,
  modelVariantSetpoints = { ...initialModelVariantState.modelVariantManager.selectedModelVariant.Setpoints },
  changeModelVariantSetpoint,
  defaultHandler,
  cancelHandler,
  intl
}) => {
  let IsEdit = false;
  const [localformErrors, setFormErrors] = useState({});
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  let { ModelId } = useParams();

  if (ModelSetpointId) {
    IsEdit = true;
  }

  // Update redux store
  const setLocalModelVariantSetpoint = currentState => {
    changeModelVariantSetpoint(currentState);
  };

  let widgetCode = IsEdit ? 'MODELVARIANTSETPOINTSEDIT' : 'MODELVARIANTSETPOINTSADD';


  //Saving
  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }

    let saveData = modelVariantSetpoints.SelectedSetpoint;
    saveData.PerformResetDefault = false;
    saveData.IsEdit = IsEdit;
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;
    saveData.ModelId = ModelId;


    if (!saveData.ModelVariantSetpointId) {
      saveData.ModelVariantSetpointId = 0;
      saveData.GuidIdentifier = uuidv4();
    }

    saveModelVariantSetpoint(saveData, widgetCode);
  };

  let selSetpointObj = null;
  if (modelVariantSetpoints.SelectedSetpoint.ModelSetpointId) {
    selSetpointObj = modelVariantSetpoints.SetpointsList.find(
      x => x.ModelSetpointId === modelVariantSetpoints.SelectedSetpoint.ModelSetpointId
    );
  }


  const validateInput = () => {
    let formErrors = {};
    let isValid = true;


    if (
      !modelVariantSetpoints ||
      !modelVariantSetpoints.SelectedSetpoint ||
      !modelVariantSetpoints.SelectedSetpoint.ModelSetpointId ||
      isRequired(modelVariantSetpoints.SelectedSetpoint.ModelSetpointId, 1)
    ) {
      formErrors.ModelSetpointId = intl.formatMessage({
        id: 'modelVariantSetpoints.setpointRequired',
        defaultMessage: 'Setpoint is a mandatory field'
      });
      isValid = false;
    }

    if (
      !modelVariantSetpoints ||
      !modelVariantSetpoints.SelectedSetpoint ||
      !modelVariantSetpoints.SelectedSetpoint.ModelSetpointId ||
      isRequired(modelVariantSetpoints.SelectedSetpoint.Value, 1)
    ) {
      formErrors.Value = intl.formatMessage({
        id: 'modelVariantSetpoints.ValueRequired',
        defaultMessage: 'Value is a mandatory field'
      });
      isValid = false;
    } else {
      if (
        selSetpointObj &&
        selSetpointObj.MinimumValue !== undefined &&
        selSetpointObj.MinimumValue !== '' &&
        selSetpointObj.MinimumValue > parseFloat(modelVariantSetpoints.SelectedSetpoint.Value)
      ) {
        formErrors.Value = intl.formatMessage({
          id: 'modelVariantSetpoints.ValueMustBeWithinRange',
          defaultMessage: 'Value must be within Min and Max range'
        });
        isValid = false;
      } else if (
        selSetpointObj &&
        selSetpointObj.MaximumValue !== undefined &&
        selSetpointObj.MaximumValue !== '' &&
        selSetpointObj.MaximumValue < parseFloat(modelVariantSetpoints.SelectedSetpoint.Value)
      ) {
        formErrors.Value = intl.formatMessage({
          id: 'modelVariantSetpoints.ValueMustBeWithinRange',
          defaultMessage: 'Value must be within Min and Max range'
        });
        isValid = false;
      }
    }

    setFormErrors(formErrors);

    return isValid;
  };

  //on control value change
  const onChange = e => {
    if (e.target.name == 'Value' && e.target.value != '') {
      setLocalModelVariantSetpoint({
        ...modelVariantSetpoints,
        SelectedSetpoint: { ...modelVariantSetpoints.SelectedSetpoint, [e.target.name]: Number(e.target.value) }
      });

    } else {
      setLocalModelVariantSetpoint({
        ...modelVariantSetpoints,
        SelectedSetpoint: { ...modelVariantSetpoints.SelectedSetpoint, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }
      });

    }

  };

  const getDefaultValue = () => {
    return modelVariantSetpoints.SelectedSetpoint && typeof modelVariantSetpoints.SelectedSetpoint.DefaultValue === 'number' &&
            modelVariantSetpoints.SelectedSetpoint.DefaultValue || null

  };



  const onCancelButtonClick = () => {
    setLocalModelVariantSetpoint({
      SelectedSetpoint: {
        ...modelVariantSetpoints.SelectedSetpoint,
        ...initialModelVariantState.modelVariantManager.selectedModelVariant.Setpoints.SelectedSetpoint,
        DefaultValue: null
      }
    });
    cancelHandler()
  }

  // if (modelVariantSetpoints.redirect) {
  //   onCancelButtonClick()
  // }

  return (
    <div className={s.modelVariantSetpoints}>
      <div className={s.modelVariantSetpointsContent}>
        <Form>
          <div className={s.editScreenRow}>
            <Row>
              {IsEdit && <Col lg={3}>
                <Form.Group controlId="formSetpointName">
                  <Form.Label>
                    <FormattedMessage id="modelVariantSetpoints.name" defaultMessage="Name" />
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="Name"
                    placeholder={intl.formatMessage({
                      id: 'modelVariantSetpoints.name',
                      defaultMessage: 'Name'
                    })}
                    value={modelVariantSetpoints.SelectedSetpoint.Name}
                    className={`${s.formControl}`}
                    disabled={true}
                  />
                </Form.Group>
              </Col>}
              <Col xs={6} lg={2}>
                <Form.Group controlId="formSetpointValue">
                  <Form.Label>
                    <FormattedMessage id="modelVariantSetpoints.selectValue" defaultMessage="Select value" />
                  </Form.Label>
                  <InputNumber
                    name="Value"
                    step=".1"
                    onInputChange={onChange}
                    value={modelVariantSetpoints.SelectedSetpoint.Value}
                    id="formSetpointValue"
                    customClassName={`${localformErrors && localformErrors.Value ? s.formControlError : ''}`}
                  />
                  {localformErrors && localformErrors.Value && (
                    <p role="alert" className={s.error}>
                      {localformErrors.Value}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col xs={6}>
                <p>&nbsp;</p>
                <p className={s.smallItalic}>
                  {(selSetpointObj && selSetpointObj.MinimumValue !== undefined && selSetpointObj.MinimumValue !== '') ||
                    (selSetpointObj && selSetpointObj.MaximumValue !== undefined && selSetpointObj.MaximumValue !== '') ? (
                    <Fragment>
                      (
                      {selSetpointObj && selSetpointObj.MinimumValue !== undefined && selSetpointObj.MinimumValue !== '' ? (
                        <Fragment>
                          <FormattedMessage id="modelVariantSetpoints.min" defaultMessage="Min" />
                          {` ${selSetpointObj.MinimumValue}`}
                        </Fragment>
                      ) : (
                        ''
                      )}
                      {selSetpointObj && selSetpointObj.MaximumValue !== undefined && selSetpointObj.MaximumValue !== '' ? (
                        <Fragment>
                          {selSetpointObj && selSetpointObj.MinimumValue !== undefined && selSetpointObj.MinimumValue !== ''
                            ? `, `
                            : ''}
                          <FormattedMessage id="modelVariantSetpoints.max" defaultMessage="Max" />
                          {` ${selSetpointObj.MaximumValue}`}
                        </Fragment>
                      ) : (
                        ''
                      )}
                      )
                    </Fragment>
                  ) : (
                    ''
                  )}
                </p>
              </Col>
            </Row>

            <Row>
              <Col lg={ModelSetpointId ? 5 : 4} xs={12}>
                <Button
                  variant="primary"
                  className={classNames(s.margin5, s.btnSaveChanges)}
                  onClick={submitForm}
                  noValidate
                  data-unittest="saveData"
                >
                  <FormattedMessage id="modelVariantSetpoints.saveModelVariantSetpoint" defaultMessage="SAVE" />
                </Button>
                {IsEdit && (
                  <Button
                    variant="outline-secondary"
                    className={classNames(s.btnCancel)}
                    onClick={() => defaultHandler(modelVariantSetpoints.SelectedSetpoint.ModelVariantSetpointId)}
                    noValidate
                    data-unittest="saveDefault"
                  >
                    <FormattedMessage id="modelVariantSetpoints.default" defaultMessage="DEFAULT" />
                  </Button>
                )}
                <Button
                  variant="outline-secondary"
                  className={classNames(s.btnCancel)}
                  onClick={onCancelButtonClick}
                  noValidate
                  data-unittest="saveCancel"
                >
                  <FormattedMessage id="modelVariantSetpoints.cancelModelVariantSetpoint" defaultMessage="CANCEL" />
                </Button>
              </Col>
              <Col lg={ModelSetpointId ? 7 : 5}></Col>
            </Row>
          </div>
        </Form>
      </div>
    </div>
  );
};

ModelVariantSetpoints.propTypes = {
  saveModelVariantSetpoint: PropTypes.func.isRequired,
  changeModelVariantSetpoint: PropTypes.func.isRequired,
  modelVariantSetpoints: PropTypes.object.isRequired,
  modelVariantSetpoints: PropTypes.array,
  cancelHandler: PropTypes.func.isRequired
};

export default injectIntl(ModelVariantSetpoints);
